<template>
  <v-flex xs12 sm12 md12>
    <v-expansion-panels>
      <v-expansion-panel>
        <v-expansion-panel-header>
          <div class="font-weight-bold subheading">
            {{ $t("modules.users.permissions") }}
          </div>
        </v-expansion-panel-header>
        <v-expansion-panel-content>
          <v-card elevation="0">
            <v-list-item three-line>
              <v-list-item-title class="pl-3">
                <v-switch
                  @change="toggleAll()"
                  v-model="toggle"
                  :label="$t('modules.users.selectAll')"
                  color="primary"
                ></v-switch>
              </v-list-item-title>
              <v-list-item-action style="width: 25%">
                <div class="text-xs-right mt-3 grey--text font-weight-bold">
                  {{ $t("app.total") }}: {{ permissions.length }}
                </div>
              </v-list-item-action>
            </v-list-item>
            <v-data-table
              ref="dataContainer"
              :headers="headers"
              :items="items"
              class="elevation-1 mx-2 mt-3 scroll"
              hide-default-footer
              style="min-height: 100%;"
              fixed-header
            >
              <template v-slot:item.view="{ item }">
                <permission-checkbox
                  :permission="item.view"
                  :disabledCheckbox="false"
                  :change="togglePermission"
                  :tooltipText="tooltipTexts[item.view]"
                ></permission-checkbox>
              </template>
              <template v-slot:item.add="{ item }">
                <permission-checkbox
                  :permission="item.add"
                  :disabledCheckbox="!permissions.includes(item.view)"
                  :tooltipText="tooltipTexts[item.add]"
                ></permission-checkbox>
              </template>
              <template v-slot:item.update="{ item }">
                <permission-checkbox
                  :permission="item.update"
                  :disabledCheckbox="!permissions.includes(item.view)"
                  :tooltipText="tooltipTexts[item.update]"
                ></permission-checkbox>
              </template>
              <template v-slot:item.delete="{ item }">
                <permission-checkbox
                  :permission="item.delete"
                  :disabledCheckbox="!permissions.includes(item.view)"
                  :tooltipText="tooltipTexts[item.delete]"
                ></permission-checkbox>
              </template>
              <template v-slot:item.update_all="{ item }">
                <permission-checkbox
                  :permission="item.update_all"
                  :disabledCheckbox="!permissions.includes(item.view)"
                  :tooltipText="tooltipTexts[item.update_all]"
                ></permission-checkbox>
              </template>
              <template v-slot:item.delete_all="{ item }">
                <permission-checkbox
                  :permission="item.delete_all"
                  :disabledCheckbox="!permissions.includes(item.view)"
                  :tooltipText="tooltipTexts[item.delete_all]"
                ></permission-checkbox>
              </template>
            </v-data-table>
          </v-card>
        </v-expansion-panel-content>
      </v-expansion-panel>
    </v-expansion-panels>
  </v-flex>
</template>

<script>
import PermissionCheckbox from "./permission-checkbox.vue";
import { PermissionEnum, getAllPermissions } from "@/mixins/permissions.js";

export default {
  name: "PermissionSection",
  components: { PermissionCheckbox },
  data() {
    return {
      toggle: false,
      headers: [
        {
          text: "",
          align: "start",
          value: "name",
          sortable: false
        },
        {
          text: this.$t("modules.users.viewPermission"),
          align: "center",
          value: "view",
          sortable: false
        },
        {
          text: this.$t("modules.users.addPermission"),
          align: "center",
          value: "add",
          sortable: false
        },
        {
          text: this.$t("modules.users.updatePermission"),
          align: "center",
          value: "update",
          sortable: false
        },
        {
          text: this.$t("modules.users.updateAllPermission"),
          align: "center",
          value: "update_all",
          sortable: false
        },
        {
          text: this.$t("modules.users.deletePermission"),
          align: "center",
          value: "delete",
          sortable: false
        },

        {
          text: this.$t("modules.users.deleteAllPermission"),
          align: "center",
          value: "delete_all",
          sortable: false
        }
      ],
      tooltipTexts: {
        [PermissionEnum.DEVICES.UPDATE]: this.$t(
          "modules.users.tooltipTexts.deviceUpdate"
        ),
        [PermissionEnum.DEVICES.UPDATE_ALL]: this.$t(
          "modules.users.tooltipTexts.deviceUpdateAll"
        ),
        [PermissionEnum.DEVICES.DELETE]: this.$t(
          "modules.users.tooltipTexts.deviceDelete"
        ),
        [PermissionEnum.DEVICES.DELETE_ALL]: this.$t(
          "modules.users.tooltipTexts.deviceDeleteAll"
        ),
        [PermissionEnum.RF_RECORDINGS.UPDATE_ALL]: this.$t(
          "modules.users.tooltipTexts.rfRecordingDownload"
        ),
        [PermissionEnum.ADMIN.UPDATE_ALL]: this.$t(
          "modules.users.tooltipTexts.adminUpdateAll"
        ),
        [PermissionEnum.ADMIN.DELETE_ALL]: this.$t(
          "modules.users.tooltipTexts.adminDeleteAll"
        ),
        [PermissionEnum.LOGS.VIEW]: this.$t(
          "modules.users.tooltipTexts.logsDownload"
        )
      }
    };
  },
  computed: {
    permissions: {
      get() {
        return this.$store.state.users.editedItem.permissions;
      },
      set(val) {
        this.$store.commit("users/updatePermissions", val);
      }
    },
    items() {
      const permissions = [
        this.getEntityPermissions(
          PermissionEnum.ENVIRONMENTS,
          this.$t("modules.users.environments")
        ),
        this.getEntityPermissions(
          PermissionEnum.USERS,
          this.$t("modules.users.title")
        ),
        this.getEntityPermissions(
          PermissionEnum.DEVICES,
          this.$t("modules.users.devices")
        ),
        this.getEntityPermissions(
          PermissionEnum.RF_RECORDINGS,
          this.$t("modules.users.devicesRfRecording")
        ),
        this.getEntityPermissions(
          PermissionEnum.APPLICATION_RULES,
          this.$t("modules.users.dataPathApplicationRules")
        ),
        this.getEntityPermissions(
          PermissionEnum.OPENVPN_PROFILE,
          this.$t("modules.users.dataPathVpnProfiles")
        ),
        this.getEntityPermissions(
          PermissionEnum.ADMIN,
          this.$t("modules.users.admin")
        ),
        this.getEntityPermissions(
          PermissionEnum.LOGS,
          this.$t("modules.users.logsAuditSystem")
        ),
        this.getEntityPermissions(
          PermissionEnum.MESSAGING_LOG,
          this.$t("modules.users.logsMessaging")
        )
      ];

      return permissions;
    },
    selectAll() {
      return getAllPermissions();
    }
  },

  watch: {
    permissions(value) {
      this.toggle = this.selectAll.every(element => value.includes(element));
      if (this.toggle) {
        this.toggleAll();
      }
    }
  },

  methods: {
    togglePermission(val) {
      if (!this.permissions.includes(val)) {
        switch (val) {
          case PermissionEnum.ENVIRONMENTS.VIEW:
            {
              let { ADD, UPDATE, DELETE } = PermissionEnum.ENVIRONMENTS;
              this.permissions = this.permissions.filter(
                x => [ADD, UPDATE, DELETE].indexOf(x) === -1
              );
            }
            break;

          case PermissionEnum.USERS.VIEW:
            {
              let { ADD, UPDATE, DELETE } = PermissionEnum.USERS;
              this.permissions = this.permissions.filter(
                x => [ADD, UPDATE, DELETE].indexOf(x) === -1
              );
            }
            break;

          case PermissionEnum.DEVICES.VIEW:
            {
              let {
                ADD,
                UPDATE,
                UPDATE_ALL,
                DELETE,
                DELETE_ALL
              } = PermissionEnum.DEVICES;
              this.permissions = this.permissions.filter(
                x =>
                  [ADD, UPDATE, UPDATE_ALL, DELETE, DELETE_ALL].indexOf(x) ===
                  -1
              );
            }
            break;

          case PermissionEnum.APPLICATION_RULES.VIEW:
            {
              let { ADD, UPDATE, DELETE } = PermissionEnum.APPLICATION_RULES;
              this.permissions = this.permissions.filter(
                x => [ADD, UPDATE, DELETE].indexOf(x) === -1
              );
            }
            break;

          case PermissionEnum.OPENVPN_PROFILE.VIEW:
            {
              let { ADD, UPDATE, DELETE } = PermissionEnum.OPENVPN_PROFILE;
              this.permissions = this.permissions.filter(
                x => [ADD, UPDATE, DELETE].indexOf(x) === -1
              );
            }
            break;

          case PermissionEnum.ADMIN.VIEW:
            {
              let { UPDATE_ALL, DELETE_ALL } = PermissionEnum.ADMIN;
              this.permissions = this.permissions.filter(
                x => [UPDATE_ALL, DELETE_ALL].indexOf(x) === -1
              );
            }
            break;

          case PermissionEnum.RF_RECORDINGS.VIEW:
            {
              let { UPDATE_ALL } = PermissionEnum.RF_RECORDINGS;
              this.permissions = this.permissions.filter(
                x => [UPDATE_ALL].indexOf(x) === -1
              );
            }
            break;
        }
      }
    },

    getEntityPermissions(permission, name) {
      const entityPermission = {};
      for (const key in permission) {
        entityPermission[key.toLowerCase()] = permission[key];
      }
      entityPermission["name"] = name;

      return entityPermission;
    },

    toggleAll() {
      if (this.toggle) {
        this.permissions = this.selectAll;
      } else {
        this.permissions = [];
      }
    }
  }
};
</script>
